<template>
  <v-list-item class="px-0 primary">
    <v-row>
      <v-col :class="['text-center text-truncate body-2 font-weight-bold', { caption: $vuetify.breakpoint.mdAndDown }]">日付</v-col>
      <v-col :class="['text-center text-truncate body-2 font-weight-bold', { caption: $vuetify.breakpoint.mdAndDown }]">支払先</v-col>
      <v-col :class="['text-center text-truncate body-2 font-weight-bold', { caption: $vuetify.breakpoint.mdAndDown }]">顧客名</v-col>
      <v-col :class="['text-center text-truncate body-2 font-weight-bold', { caption: $vuetify.breakpoint.mdAndDown }]">勘定科目</v-col>
      <v-col :class="['text-center text-truncate body-2 font-weight-bold', { caption: $vuetify.breakpoint.mdAndDown }]">利用額</v-col>
      <v-col :class="['text-center text-truncate body-2 font-weight-bold', { caption: $vuetify.breakpoint.mdAndDown }]">利用内容</v-col>
    </v-row>
  </v-list-item>
</template>

<script>
export default {
  name: 'authorBBookPreviewDcHeader'
}
</script>